import React from "react";
import { useTranslation } from "react-i18next";
import {
  convertCount2ToSeconds,
  convertTimeTakenToSeconds,
} from "../../Utils/MeetingFunctions";
import moment from "moment";
import { useNavigate } from "react-router-dom";

function Moments({ meetingsData, onMomentSelect, selectedMoment }) {
  const moments = meetingsData || [];
  const [t] = useTranslation("global");
  const navigate = useNavigate();

  if (!moments.length) return <div>No moments found</div>;

  return (
    <div className="card rounded-0 h-100">
      <div className="card-body">
        <h5>Moments</h5>
        <div
          className="moments-list"
          style={{ height: "80vh", overflowY: "auto" }}
        >
          {moments.map((meeting) => (
            <div
              key={meeting.id}
              className={`moment-item p-3 mb-2 cursor-pointer invite ${
                selectedMoment?.id === meeting.id
                  ? "bg-light border-start border-primary border-3"
                  : ""
              }`}
              onClick={() => onMomentSelect(meeting)}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div className="d-flex align-items-center gap-3">
                  <h6 className="position-relative">
                    {meeting.title}
                    {meeting.unread_messages_count > 0 && (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary" style={{ fontSize: "0.6rem" }}>
                        {meeting.unread_messages_count}
                        <span className="visually-hidden">unread messages</span>
                      </span>
                    )}
                  </h6>
                </div>
                <div>
                  {meeting?.status === "closed" ? (
                    <span className="badge inprogrss">
                      {t("badge.finished")}
                    </span>
                  ) : meeting?.status === "in_progress" ? (
                    <span
                      className={`${
                        meeting?.steps?.some(
                          (item) =>
                            item?.step_status === "in_progress" &&
                            convertTimeTakenToSeconds(item?.time_taken) >
                              convertCount2ToSeconds(
                                item?.count2,
                                item?.time_unit
                              )
                        )
                          ? "status-badge-red-invite"
                          : "status-badge-inprogress-invite"
                      } badge`}
                    >
                      {t("badge.inprogress")}
                    </span>
                  ) : meeting?.status === "active" ? (
                    <span
                      className={`badge ${
                        moment().isAfter(
                          moment(
                            `${meeting?.date} ${meeting?.start_time}`,
                            "YYYY-MM-DD HH:mm"
                          )
                        )
                          ? "late"
                          : "future"
                      }`}
                    >
                      {moment().isAfter(
                        moment(
                          `${meeting?.date} ${meeting?.start_time}`,
                          "YYYY-MM-DD HH:mm"
                        )
                      )
                        ? t("badge.late")
                        : t("badge.future")}
                    </span>
                  ) : meeting?.status === "to_finish" ? (
                    <span className="badge status-badge-finish">
                      {t("badge.finish")}
                    </span>
                  ) : meeting?.status === "todo" ? (
                    <span className="badge status-badge-green">
                      {t("badge.Todo")}
                    </span>
                  ) : (
                    <span className="badge inprogrss">
                      {t("badge.finished")}
                    </span>
                  )}
                </div>
              </div>
              <small className="text-muted">
                {meeting.objective}
              </small>
          <h6 className="text-muted mt-3">
  {meeting?.last_message_date && new Date(meeting?.last_message_date).toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false, // 24-hour format
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // User's detected timezone
  })}
</h6>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Moments;